module.exports = require("@vernier/godirect");